import styled from 'styled-components';

const HomeMobilStyle = styled.div`
  .menu {
    border-top: 0.5px solid var(--blue);
    position: absolute;
    display: none;
    top: 5.4vh;
    margin-top: calc(25px + var(--marginvw) * 2);
    left: 0px;
    flex-direction: column;
    padding-bottom: 10vh;
    width: 100%;
    -moz-box-align: baseline;
    align-items: baseline;
    display: flex;
    -moz-box-pack: justify;
    justify-content: space-between;
    height: 77vh;
    background-color: white;
    align-items: center;
    padding-top: 40%;

    a{
        height: 30%;
  width: 100%;
    }
  }



`;
export default HomeMobilStyle;
